import styled from 'styled-components';

export type VipTier = 'bronze' | 'silver' | 'gold' | 'emerald' | 'diamond';

const borderGradients: Record<VipTier, string> = {
  bronze: 'linear-gradient(180deg, #97622e 0%, #6f5e56 100%)',
  silver: 'linear-gradient(180deg, #a3a3a3 0%, #f7f8fa 100%)',
  gold: 'linear-gradient(180deg, #a56c17 0%, #f4d78e 100%)',
  emerald: 'linear-gradient(180deg, #26cd96 0%, #b9fddc 100%)',
  diamond: 'linear-gradient(180deg, #08d7ff 0%, #e2f2ff 100%)',
};

const innerGradients: Record<VipTier, string> = {
  bronze:
    'linear-gradient(180deg, #a9734e 0%, #e2b69d 36.54%, #784318 76.44%, #855639 99.52%)',
  silver:
    'linear-gradient(183deg, #e8e9e9 2.3%, #fdfdfb 37.44%, #94979d 73.22%, #c5c7cc 96.75%)',
  gold: 'linear-gradient(180deg, #fbf2ae 0%, #a26813 50%, #d9aa56 100%)',
  emerald:
    'linear-gradient(180deg, #c9fee2 0%, #6df7c0 50%, #26d39a 75%, #219a72 87.5%, #aaa 100%)',
  diamond:
    'linear-gradient(180deg, #72b8ff 3.36%, #e9ffff 27.52%, #05d7ff 51.68%, #74e9ff 75.84%, #027fff 100%)',
};

export const darkTextTiers: VipTier[] = ['silver', 'emerald', 'diamond'];

interface TierProps {
  $tier: VipTier;
}

export const ScVipBadge = styled.div<TierProps>`
  display: flex;
  flex-shrink: 0;
  border-radius: 12px;
  padding: 1px;
  width: 50px;
  background: ${({ $tier }) => borderGradients[$tier]};
`;

export const ScVipBadgeInner = styled.div<TierProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 4px 0px;
  gap: 2px;
  border-radius: 10px;
  text-align: center;
  text-shadow: 1px 0 0 rgba(0, 0, 0, 0.4);
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0;
  background: ${({ $tier }) => innerGradients[$tier]};
  color: ${({ $tier, theme }) => (darkTextTiers.includes($tier) ? theme.blackColor : 'inherit')};
  white-space: nowrap;
`;
